import Layout from "common/layout/layout.component";
import ProtectedAppRoutes from "common/routes/protected-app.routes";

export function ProtectedApp() {
  return (
    <Layout>
      <ProtectedAppRoutes />
    </Layout>
  );
}
